<template>
  <div class="extras-pricing-component" ref="wrapper">
    <div v-if="developmentsWithPrices.length > 0" class="card card-body col-md-6 mb-4">
      <h4>Copy Pricing</h4>
      <p>This allows you to copy pricing from another development's house type. <strong>Warning:</strong> this will
        remove all pricing before copying the new pricing.</p>

      <div class="form-group">
        <label for="copy_development">Development</label>
        <select v-model="copyDevelopment" name="copy_development" id="copy_development" class="form-control">
          <option :value="null">Select a development</option>
          <option v-for="development in developmentsWithPrices" :value="development">{{
              development.development.name
            }}
          </option>
        </select>
      </div>

      <div v-if="copyDevelopment" class="form-group">
        <label for="copy_development_house_type_id">House Type</label>
        <select v-model="copyDevelopmentHouseTypeId" name="copy_development_house_type_id"
                id="copy_development_house_type_id" class="form-control">
          <option :value="null">Select a house type</option>
          <option v-for="houseType in copyDevelopment.house_types" :value="houseType.development_house_type_id">{{
              houseType.name
            }}
          </option>
        </select>
      </div>

      <button v-if="copyDevelopmentHouseTypeId" @click="copyPricing" class="btn btn-primary">Copy Pricing</button>
    </div>

    <div
      v-for="productCategory in productCategories"
      :key="productCategory.id"
      class="product-category"
    >
      <h4 class="mb-4">{{ productCategory.name }}</h4>

      <div
        v-for="product in productCategory.products_without_parents"
        :key="product.id"
        class="product row mb-2"
      >
        <div class="col-12 col-xl-4">
          <label
            :for="'product-label-' + product.id"
            :class="product.type === 'matrix' ? 'mb-4' : ''"
          >{{ product.name }}</label
          >
        </div>
        <div class="col-12 col-xl-3">
          <div
            v-if="product.type !== 'matrix'"
            class="input-group mb-2"
          >
            <div class="input-group-prepend">
              <div class="input-group-text">£</div>
            </div>
            <input
              type="number"
              class="form-control"
              :id="'product-label-' + product.id"
              v-model="prices[product.id]"
              @input="updateChanged(product.id)"
            />
            <div class="input-group-append">
              <div class="input-group-text">ex. VAT</div>
            </div>
          </div>
          <div
            v-if="errors['prices.' + product.id]"
            class="alert alert-danger"
          >
            <ul class="list-style-none mb-0">
              <li class="mb-0">
                <small
                  v-for="error in errors[
                                        'prices.' + product.id
                                    ]"
                  :key="error"
                >{{ error }}</small
                >
              </li>
            </ul>
          </div>
        </div>

        <div v-if="changed[product.id]" class="col-12 col-xl-4">
          <button
            @click="syncPrices()"
            type="button"
            class="btn btn-success btn-sm"
            :disabled="loading"
          >
            <span v-if="!loading">Save All</span>
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span v-if="loading">Loading...</span>
          </button>
        </div>

        <div
          v-for="product in product.children"
          :key="product.id"
          class="product col-12 mb-2"
        >
          <div class="row">
            <div class="col-12 col-xl-4">
              <label :for="'product-label-' + product.id">{{
                  product.name
                }}</label>
            </div>
            <div class="col-12 col-xl-3">
              <div
                v-if="product.type !== 'matrix'"
                class="input-group mb-2"
              >
                <div class="input-group-prepend">
                  <div class="input-group-text">£</div>
                </div>
                <input
                  type="number"
                  class="form-control"
                  :id="'product-label-' + product.id"
                  v-model="prices[product.id]"
                  @input="updateChanged(product.id)"
                />
                <div class="input-group-append">
                  <div class="input-group-text">ex. VAT</div>
                </div>
              </div>
              <div
                v-if="errors['prices.' + product.id]"
                class="alert alert-danger"
              >
                <ul class="list-style-none mb-0">
                  <li class="mb-0">
                    <small
                      v-for="error in errors[
                                                'prices.' + product.id
                                            ]"
                      :key="error"
                    >{{ error }}</small
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div v-if="changed[product.id]" class="col-12 col-xl-2">
              <button
                @click="syncPrices()"
                type="button"
                class="btn btn-success btn-sm"
                :disabled="loading"
              >
                <span v-if="!loading">Save All</span>
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span v-if="loading">Loading...</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading" class="mt-4 spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      prices: {},
      changed: [],
      errors: {},
      copyDevelopment: null,
      copyDevelopmentHouseTypeId: null,
    };
  },

  props: {
    developmentHouseType: {
      type: Object,
      default: null
    },
    productCategories: {
      type: Array,
      default: null
    },
    preloadPrices: {
      type: Array | Object,
      default: {}
    },
    developmentsWithPrices: {
      type: Array,
      default: []
    },
  },

  watch: {
    copyDevelopment: function (development) {
      this.copyDevelopmentHouseTypeId = null;
    },
  },

  created() {
    this.prices = this.preloadPrices;
  },

  methods: {
    syncPrices() {
      this.loading = true;
      this.errors = {};

      axios
        .post(
          `${window.api_url}/admin/developments/extras/${this.developmentHouseType.id}`,
          {
            prices: this.prices
          }
        )
        .then(res => {
          if (res.data && res.data.success) {
            this.changed = [];
            notyf.success('Prices updated successfully.');
          }
        })
        .catch(err => {
          this.loading = false;

          if (err.response && err.response.status === 422) {
            this.errors = err.response.data.errors;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    updateChanged(productId) {
      this.changed[productId] = true;
    },

    copyPricing() {
      if (!this.copyDevelopmentHouseTypeId) {
        return notyf.error('Please select a development and house type to copy pricing from first.');
      }

      if (!confirm('Are you sure you want to copy pricing from this development and house type?')) {
        return;
      }

      this.loading = true;

      axios
        .post(
          `${window.api_url}/admin/developments/extras/${this.developmentHouseType.id}/copy-pricing`,
          {
            development_house_type_id: this.copyDevelopmentHouseTypeId
          }
        )
        .then(res => {
          if (res.data && res.data.success) {
            this.prices = res.data.prices;
            this.changed = [];
            notyf.success('Pricing copied successfully.');
          }
        })
        .catch(err => {
          this.loading = false;

          if (err.response && err.response.status === 422) {
            this.errors = err.response.data.errors;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
};
</script>
